@if (isLoading) {
  <div class="container mobile-container container-space">
    <div class="d-grid w-100 basket-box">
      <div class="panel order-box basket-skeleton-panel">
        <div class="basket-skeleton-header d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column gap-2">
            <span aria-hidden="true"
                  class="skeleton skeleton-line basket-skeleton-title"></span>
            <span aria-hidden="true"
                  class="skeleton skeleton-line basket-skeleton-subtitle"></span>
          </div>
          <span aria-hidden="true"
                class="skeleton basket-skeleton-icon"></span>
        </div>
        @for (placeholder of basketSkeletonPlaceholders; track $index) {
          <div class="basket-skeleton-item d-flex align-items-center">
            <div aria-hidden="true"
                 class="skeleton basket-skeleton-image"></div>
            <div class="basket-skeleton-details flex-grow-1">
              <span aria-hidden="true"
                    class="skeleton skeleton-line basket-skeleton-item-title"></span>
              <span aria-hidden="true"
                    class="skeleton skeleton-line basket-skeleton-item-meta"></span>
              <div class="basket-skeleton-controls d-flex align-items-center justify-content-between">
                <span aria-hidden="true"
                      class="skeleton skeleton-line basket-skeleton-price"></span>
                <span aria-hidden="true"
                      class="skeleton skeleton-line basket-skeleton-counter"></span>
              </div>
            </div>
          </div>
        }
        <div class="basket-skeleton-financial">
          <span aria-hidden="true"
                class="skeleton skeleton-line basket-skeleton-financial-title"></span>
          <span aria-hidden="true"
                class="skeleton skeleton-line basket-skeleton-financial-value"></span>
        </div>
        <div aria-hidden="true"
             class="skeleton basket-skeleton-progress"></div>
        <span aria-hidden="true"
              class="skeleton skeleton-line basket-skeleton-button"></span>
      </div>
      @if (isBasketFinalStep || (router.url.startsWith(`/${RouteUtil.BASKET_COMPONENT}`) && !isMobile)) {
        <div class="panel payment-box checkout-skeleton-panel">
          <span aria-hidden="true"
                class="skeleton skeleton-line checkout-skeleton-title"></span>
          <div class="checkout-skeleton-section">
            <span aria-hidden="true"
                  class="skeleton skeleton-line checkout-skeleton-heading"></span>
            @for (placeholder of checkoutSkeletonPlaceholders; track $index) {
              <div class="checkout-skeleton-option d-flex align-items-center gap-3">
                <span aria-hidden="true"
                      class="skeleton checkout-skeleton-icon"></span>
                <div class="checkout-skeleton-option-text flex-grow-1">
                  <span aria-hidden="true"
                        class="skeleton skeleton-line checkout-skeleton-option-title"></span>
                  <span aria-hidden="true"
                        class="skeleton skeleton-line checkout-skeleton-option-meta"></span>
                </div>
                <span aria-hidden="true"
                      class="skeleton checkout-skeleton-selector"></span>
              </div>
            }
          </div>
          <div class="checkout-skeleton-section">
            <span aria-hidden="true"
                  class="skeleton skeleton-line checkout-skeleton-heading"></span>
            @for (placeholder of checkoutSkeletonPlaceholders; track $index) {
              <div class="checkout-skeleton-option d-flex align-items-center gap-3">
                <span aria-hidden="true"
                      class="skeleton checkout-skeleton-icon"></span>
                <div class="checkout-skeleton-option-text flex-grow-1">
                  <span aria-hidden="true"
                        class="skeleton skeleton-line checkout-skeleton-option-title"></span>
                </div>
                <span aria-hidden="true"
                      class="skeleton checkout-skeleton-selector"></span>
              </div>
            }
          </div>
          <div class="checkout-skeleton-financial">
            <span aria-hidden="true"
                  class="skeleton skeleton-line checkout-skeleton-financial-line"></span>
            <span aria-hidden="true"
                  class="skeleton skeleton-line checkout-skeleton-financial-line"></span>
            <span aria-hidden="true"
                  class="skeleton skeleton-line checkout-skeleton-financial-total"></span>
          </div>
          <span aria-hidden="true"
                class="skeleton checkout-skeleton-button"></span>
        </div>
      }
    </div>
  </div>
} @else if (orders?.length === 0) {
  <div class="container mobile-container container-space empty-order-box order-box">
    <div class="head-success d-flex justify-content-center">
      <img src="/icons/empty-list.svg">
    </div>
    <div class="col-12 mt-5 px-4">
      <app-frontend-button [title]="'NoProductFound'"></app-frontend-button>
    </div>
  </div>
} @else {
  <div class="container mobile-container container-space">
    <div class="d-grid w-100 basket-box">
      @if (isBasketFinalStep || (router.url.startsWith(`/${RouteUtil.BASKET_COMPONENT}`) && !isMobile)) {
        <app-check-out></app-check-out>
      }
      @if (!isBasketFinalStep) {
        <div class="panel order-box">
          <div class="col-12 d-flex justify-content-between align-items-center mb-3">
            <div class="Title-box-shopping d-flex flex-column align-items-start justify-content-start">
              <span>{{ 'ShoppingCart' | translate }}</span>
              <img class="mt-2 d-lg-block d-none"
                   src="/icons/line-categories.svg">
            </div>
            <img class="cursor-pointer"
                 src="/icons/edit-2.svg">
          </div>
          @for (order of orders; track $index) {
            <div>
              <div [ngClass]="{'disabled-card': order.ServicePrice?.IsOutOfServiceTime}"
                   class="card-food d-flex align-items-center">
                <div class="circle-food d-flex justify-content-center align-items-center">
                  <img [src]="formatImage('x', order.ServicePrice.Service.Images[0])"
                       alt="{{ order.ServicePrice.Service.Title }}"
                       class="service-image">
                </div>
                <div class="flex-grow-1 sub-card">
                  <div class="card-header">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="title-food">{{ order.ServicePrice.Service.Title }}</span>
                      <div class="d-flex align-items-center">
                      </div>
                    </div>
                  </div>
                  <div class="card-content">
                    @if (order.ServicePrice?.ServicePriceAdditives?.length > 0) {
                      <div class="paragraph-text d-flex align-items-center justify-content-between">
                        <p (click)="openAdditivesClicked(order)"
                           class="cursor-pointer">
                          <img src="/icons/info-circle-stroke.svg">
                          {{ 'Additives' | translate }}
                        </p>
                        <span>{{ order.OrderServicePriceAdditives?.length || 0 }} مورد</span>
                      </div>
                    }
                  </div>
                  <div class="card-footer">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center price-food">
                        <p class="me-2">{{ StringUtil.numberAsCurrency(getOrderTotalPrice(order)) }}</p>
                        <span class="currency">ریال</span>
                      </div>
                      @if (!order.ServicePrice?.IsOutOfServiceTime) {
                        <div class="d-flex align-items-center justify-content-between gap-2">
                          <img (click)="onUpdateOrderCountClicked(order, (order.Count - 1))"
                               class="cursor-pointer remove-icon"
                               src="/icons/bag.svg">
                          <span class="count-text">{{ order.Count }}</span>
                          <img (click)="onUpdateOrderCountClicked(order, (order.Count + 1))"
                               class="cursor-pointer add-icon"
                               src="/icons/add-square.svg">
                        </div>
                      } @else {
                        <span class="out-of-service-text">خارج از زمان سرویس دهی</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if ((router.url.includes(RouteUtil.BASKET_COMPONENT) && isMobile) || (router.url.includes(RouteUtil.MENU_COMPONENT) && !isMobile)) {
            <div class="financial-box">
              <div class="financial-content"
                   style="border-bottom: none">
                <div class="d-flex align-items-center justify-content-between">
                  <span>{{ 'Sum' | translate }}</span>
                  <p class="text-start">{{ StringUtil.numberAsCurrency(calculatePriceSum()) }} ریال</p>
                </div>
              </div>
            </div>
            @if (getRemainingAmountUntilMinimum() <= 0) {
              <app-frontend-button (click)="onShowPaymentClicked()"
                                   [title]="hasAccount() ? 'OrderCompletionAndPayment' : 'LoginToAccount'"></app-frontend-button>
            }
            @if (getRemainingAmountUntilMinimum() > 0) {
              <div class="minimum-purchase-progress">
                <div class="progress-labels">
            <span class="remaining-amount">{{ StringUtil.numberAsCurrency(getRemainingAmountUntilMinimum()) }}
              ریال مانده تا حداقل خرید</span>
                  <span class="minimum-amount">{{ StringUtil.numberAsCurrency(getMinimumPurchaseAmount()) }} ریال</span>
                </div>
                <div class="progress-bar-container">
                  <div [style.width.%]="getProgressPercentage()"
                       class="progress-bar-fill"></div>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
}
